import React from 'react';
import { StaticImage } from 'gatsby-plugin-image';
import DownloadButtons from '../ui/DownloadButtons';
import { NomadagoPath } from '../../assets/icons/NomadagoPath';

export const HeroSection = () => (
  <section className="container flex flex-col md:flex-row gap-12 md:gap-5 py-10 md:min-h-[70vh] lg:min-h-[90vh] items-center">
    <div className="flex flex-col items-center flex-1 text-center md:text-left md:items-start">
      <NomadagoPath className="w-32 mb-6" />

      <h1 className="mb-4 text-5xl font-bold text-yellow-400 lg:text-7xl">
        The <span className="text-blue-500">Essential</span> App{' '}
        <span className="text-blue-500">for</span> Digital
        <span className="text-blue-500"> Nomads</span>
      </h1>

      <p className="mb-6 text-lg lg:text-2xl">
        Plan trips with friends, browse verified colivings, and connect with a
        global nomad community.
      </p>

      <DownloadButtons buttonClassName="max-w-48" />
    </div>

    <div className="flex justify-center flex-1">
      <StaticImage
        className="w-full"
        width={675}
        height={656}
        src="../../assets/images/homepage/hero.png"
        alt="Nomadago App Screenshots"
        placeholder="none"
        backgroundColor="transparent"
      />
    </div>
  </section>
);
